
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
// import { AppConstant } from './../../shared/constant/app.constant';
import { AuthHttp } from '../../admin/services/token.service';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};
@Injectable()
export class StaffRoleService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    get() {
        return this.http.get(`setups/default-staff-role`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getStaffRoles() {
        return this.http.get(`setups/staff-role/company`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getStaffRoleByStaffId() {
        return this.http.get(`setups/staff-role-by-staffid`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    StaffReportingTo(staffCode) {
        return this.http.get(`setup/staff-reporting/${staffCode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    StaffSupervosorReporting(staffCode) {
        return this.http.get(`setup/staff-reporting-search/${staffCode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    StaffSupervosor(staffCode) {
        return this.http.get(`setup/supervisor/${staffCode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    StaffInformation(staffCode) {
        return this.http.get(`setup/staff/information/${staffCode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    StaffMIS(staffCode) {
        return this.http.get(`setup/staff/mis/${staffCode}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    StaffSearch(searchQuery) {
        return this.http.get(`setup/staff/search/${searchQuery}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    addUpdateStaffRole(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/staff-role`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    getAllStaffRoleAwaitingApproval() {
        return this.http.get(`setups/staff-role-approval`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    goForApproval(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/staff-role/approval`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    StaffRoles() {
        return this.http.get(`setup/staff/roles`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

}